import { GridColumns } from '@mui/x-data-grid-pro';
import React from 'react';
import { DateTimeFormat, getLocalDateTime } from 'src/common';
import {
  DownloadTemplatePayload,
  ReportTemplate,
  TemplateType,
} from '../store/types';
import { ReportTemplateCell } from './ReportTemplateCell';

interface Props {
  setEditRow: (row: ReportTemplate, type: TemplateType) => void;
  downloadTemplate: (payload: DownloadTemplatePayload) => void;
}

export const ReportTemplateColumns = ({
  setEditRow,
  downloadTemplate,
}: Props): GridColumns<ReportTemplate> => [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'createdOn',
      headerName: 'Created on',
      flex: 1,
      valueFormatter: (params) =>
        getLocalDateTime(params.value, DateTimeFormat.DateTime),
    },
    {
      field: 'updatedOn',
      headerName: 'Updated on',
      flex: 1,
      valueFormatter: (params) =>
        getLocalDateTime(params.value, DateTimeFormat.DateTime),
    },
    {
      field: 'wordTemplateId',
      headerName: 'WordTemplateId',
      flex: 1.5,
      sortable: false,
      renderCell: (params) => (
        <ReportTemplateCell
          row={params.row}
          templateType="Word"
          onEdit={setEditRow}
          onDownload={downloadTemplate}
        />
      ),
    },
    {
      field: 'excelTemplateId',
      headerName: 'ExcelTemplateId',
      flex: 1.5,
      sortable: false,
      renderCell: (params) => (
        <ReportTemplateCell
          row={params.row}
          templateType="Excel"
          onEdit={setEditRow}
          onDownload={downloadTemplate}
        />
      ),
    },
  ];
